<template>
  <div class="app-container">
    <!-- 主容器 -->
    <el-row :gutter="20">
      <el-col :span="24" :xs="24">
        <!-- 搜索表单 -->
        <el-form :model="queryParams" ref="queryParams" size="small" v-show="showSearch" label-width="120px">
          <el-row class="ledger-search-toggle-row" :gutter="24">
            <el-col :span="24" class="ledger-search-toggle-col">
              <el-button type="text" class="ledger-search-toggle-btn" @click="searchFiltersExpanded = !searchFiltersExpanded">
                <i :class="searchFiltersExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                {{ searchFiltersExpanded ? '收起筛选条件' : '展开筛选条件' }}
              </el-button>
            </el-col>
          </el-row>

          <div v-show="searchFiltersExpanded" class="ledger-search-filters">
            <!-- 搜索条件行1 -->
            <el-row :gutter="24">
              <!-- 客户名称搜索 -->
              <el-col :span="5">
                <el-form-item label="客户名称" prop="compNames">
                  <el-input v-model="queryParams.compNames" placeholder="请输入客户名称" />
                  <CustomerDetails v-model="queryParams.compNames" />
                </el-form-item>
              </el-col>
              <!-- 使用单位搜索 -->
              <el-col :span="5">
                <el-form-item label="使用单位" prop="usingUnit">
                  <el-input v-model="queryParams.usingUnit" placeholder="请输入使用单位" clearable />
                </el-form-item>
              </el-col>
              <!-- 项目名称搜索 -->
              <el-col :span="5">
                <el-form-item label="小区名称" prop="houseName">
                  <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable />
                </el-form-item>
              </el-col>
              <!-- 识别码搜索 -->
              <el-col :span="5">
                <el-form-item label="识别码" prop="OIDNO">
                  <el-input v-model="queryParams.OIDNO" placeholder="请输入识别码" clearable />
                </el-form-item>
              </el-col>
              <!-- 区域(市级)搜索 -->
              <el-col :span="4">
                <el-form-item label="区域(市级)" prop="eqpAreaName">
                  <el-select v-model="queryParams.eqpAreaName" placeholder="请选择区域" clearable style="width:100%">
                    <el-option label="福州市" value="福州市"></el-option>
                    <el-option label="厦门市" value="厦门市"></el-option>
                    <el-option label="泉州市" value="泉州市"></el-option>
                    <el-option label="漳州市" value="漳州市"></el-option>
                    <el-option label="莆田市" value="莆田市"></el-option>
                    <el-option label="三明市" value="三明市"></el-option>
                    <el-option label="南平市" value="南平市"></el-option>
                    <el-option label="龙岩市" value="龙岩市"></el-option>
                    <el-option label="宁德市" value="宁德市"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 搜索条件行2 -->
            <el-row :gutter="24">
              <!-- 产品编号搜索 -->
              <el-col :span="5">
                <el-form-item label="产品编号" prop="factoryCod">
                  <el-input v-model="queryParams.factoryCod" placeholder="请输入产品编号" clearable />
                </el-form-item>
              </el-col>
              <!-- 层高搜索 -->
              <el-col :span="5">
                <el-form-item label="层高" prop="eleFloorNumber">
                  <el-input v-model.number="queryParams.eleFloorNumber" placeholder="请输入层高" clearable type="number" />
                </el-form-item>
              </el-col>
              <!-- 到检年月搜索 -->
              <el-col :span="5">
                <el-form-item label="到检年月" prop="inspectionMonthList">
                  <el-date-picker v-model="queryParams.inspectionMonthList" type="months" placeholder="请选择到检年月" clearable value-format="yyyy-MM" style="width: 100%;" />
                </el-form-item>
              </el-col>
              <!-- 检测员搜索 -->
              <el-col :span="5">
                <el-form-item label="检测员" prop="employeeName">
                  <el-input v-model="queryParams.employeeName" placeholder="请输入检测员姓名" clearable />
                </el-form-item>
              </el-col>
              <!-- 符合性声明是否上传 -->
              <el-col :span="4">
                <el-form-item label="符合性声明" prop="conformanceStatus">
                  <el-select v-model="queryParams.conformanceStatus" placeholder="请选择" clearable style="width:100%">
                    <el-option label="已上传" :value="1"></el-option>
                    <el-option label="未上传" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 搜索条件行3 -->
            <el-row :gutter="24">
              <!-- 计划检测时间搜索 -->
              <el-col :span="5">
                <el-form-item label="派单日期" prop="orderDateRange">
                  <el-date-picker v-model="queryParams.orderDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
                                  style="width: 100%;" />
                </el-form-item>
              </el-col>
              <!-- 实际检测时间搜索 -->
              <!-- <el-col :span="5">
              <el-form-item label="实际检测时间" prop="receivedDateRange">
                <el-date-picker v-model="queryParams.receivedDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
                                style="width: 100%;" />
              </el-form-item>
            </el-col> -->
              <!-- 邮寄时间搜索 -->
              <!-- 报告打印 -->
              <el-col :span="5">
                <el-form-item label="报告打印" prop="isPrinted">
                  <el-select v-model="queryParams.isPrinted" placeholder="请选择" clearable style="width:100%">
                    <el-option label="已打印" :value="1"></el-option>
                    <el-option label="未打印" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="邮寄时间" prop="mailingDateRange">
                  <el-date-picker v-model="queryParams.mailingDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
                                  style="width: 100%;" />
                </el-form-item>
              </el-col>
              <!-- 检测时间范围 -->
              <el-col :span="5">
                <el-form-item label="检测日期" prop="testDateRange">
                  <el-date-picker v-model="queryParams.testDateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
                                  style="width: 100%;" />
                </el-form-item>
              </el-col>
              <!-- 内部编号搜索 -->
              <el-col :span="4">
                <el-form-item label="内部编号" prop="eqpInnerCod">
                  <el-input v-model="queryParams.eqpInnerCod" placeholder="请输入内部编号" clearable />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 搜索条件行4 -->
            <el-row :gutter="24">
              <!-- 未上传原因搜索 -->
              <el-col :span="5">
                <el-form-item label="未上传原因" prop="ispinfoSubmitMsg">
                  <el-input v-model="queryParams.ispinfoSubmitMsg" placeholder="请输入未上传原因" clearable />
                </el-form-item>
              </el-col>

              <!-- 是否回款 -->
              <el-col :span="5">
                <el-form-item label="是否回款" prop="receiptStatus">
                  <el-select v-model="queryParams.receiptStatus" placeholder="请选择" clearable style="width:100%">
                    <el-option label="已回款" :value="1"></el-option>
                    <el-option label="未回款" :value="-1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 发票状态 -->
              <el-col :span="5">
                <el-form-item label="发票状态" prop="applyStatus">
                  <el-select v-model="queryParams.applyStatus" placeholder="请选择" clearable style="width:100%">
                    <el-option label="已开票" :value="1"></el-option>
                    <el-option label="开票中" :value="0"></el-option>
                    <el-option label="未开票" :value="-1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- 报告邮寄 -->
              <el-col :span="5">
                <el-form-item label="报告邮寄" prop="isMailed">
                  <el-select v-model="queryParams.isMailed" placeholder="请选择" clearable style="width:100%">
                    <el-option label="已邮寄" :value="1"></el-option>
                    <el-option label="未邮寄" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 报告状态（多选，默认全部） -->
              <el-col :span="4">
                <el-form-item label="报告状态" prop="reportState">
                  <el-select v-model="queryParams.reportState" placeholder="请选择状态" clearable multiple collapse-tags style="width:100%" @change="onReportStateChange">
                    <el-option label="全部" value="全部" />
                    <el-option label="未下载" value="未下载" />
                    <el-option label="下载失败" value="下载失败" />
                    <el-option label="已下载" value="已下载" />
                    <el-option label="未派单" value="未派单" />
                    <el-option label="预派单" value="预派单" />
                    <el-option label="已派单" value="已派单" />
                    <el-option label="派单已接收" value="派单已接收" />
                    <el-option label="已撤销" value="已撤销" />
                    <el-option label="暂存" value="暂存" />
                    <el-option label="退回" value="退回" />
                    <el-option label="待整改" value="待整改" />
                    <el-option label="待提交" value="待提交" />
                    <el-option label="待审核" value="待审核" />
                    <el-option label="待签发" value="待签发" />
                    <el-option label="已签发未上传" value="已签发未上传" />
                    <el-option label="已上传" value="已上传" />
                    <el-option label="上传失败" value="上传失败" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 搜索条件行5 -->
            <el-row :gutter="24">
              <!-- 内部编号搜索 -->
              <el-col :span="5">
                <el-form-item label="内部编号" prop="eqpInnerCod">
                  <el-input v-model="queryParams.eqpInnerCod" placeholder="请输入内部编号" clearable />
                </el-form-item>
              </el-col>
              <!-- 收款时间搜索 -->
              <el-col :span="5">
                <el-form-item label="收款时间" prop="receiptTimeRange">
                  <el-date-picker v-model="queryParams.receiptTimeRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" clearable
                                  style="width: 100%;" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- 功能按钮区域 -->
          <div style="text-align: center;margin-bottom: 10px;">
            <PermissionMethodToolbar :url="url" :id="'toolbar'" @handleSearch="handleQuery" @exportToExcel="exportToExcel" />
          </div>

          <!-- 数据表格（固定列 + 合计行：需配合下方样式，避免固定层挡住横向滚动条） -->
          <div ref="ledgerTableWrap" class="ledger-mgmt-table" v-loading="loading" element-loading-text="正在查询数据..." element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(0, 0, 0, 0.5)">
            <el-table ref="ledgerTable" id="table" :data="tableData" border style="width: 100%; margin-top: 20px" :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }"
                      show-summary :summary-method="getSummaries" :height="tableHeight">
              <el-table-column type="index" label="序号" align="center" fixed="left" width="50"></el-table-column>
              <!-- 报告状态列 -->
              <el-table-column label="报告状态" align="left" prop="reportState" min-width="100" show-overflow-tooltip>
                <!-- <template slot-scope="scope">
                <el-tag :type="scope.row.reportStatus === '1' ? 'success' : 'info'">
                  {{ scope.row.reportStatus === '1' ? '已上传' : '未上传' }}
                </el-tag>
              </template> -->
              </el-table-column>
              <!-- 客户名称列 -->
              <el-table-column label="客户名称" align="left" prop="compName" min-width="150" show-overflow-tooltip fixed="left"></el-table-column>
              <!-- 使用单位列 -->
              <el-table-column label="使用单位" align="left" prop="usingUnit" min-width="150" show-overflow-tooltip></el-table-column>
              <!-- 项目名称列 -->
              <!-- <el-table-column label="小区名称" align="left" prop="projectName" min-width="220" show-overflow-tooltip></el-table-column> -->
              <!-- 小区名称列 -->
              <el-table-column label="小区名称" align="left" prop="houseName" min-width="150" show-overflow-tooltip></el-table-column>

              <!-- 现场联系人及电话列 -->
              <el-table-column label="现场联系人及电话" align="left" prop="siteContact" min-width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.siteContact }} /{{ scope.row.siteContactTel }}</span>
                </template>
              </el-table-column>
              <!-- 识别码列 -->
              <el-table-column label="识别码" align="left" prop="OIDNO" min-width="120" show-overflow-tooltip></el-table-column>
              <!-- 内部编号列 -->
              <el-table-column label="内部编号" align="left" prop="EQP_INNER_COD" min-width="120" show-overflow-tooltip></el-table-column>
              <!-- 委托编号列 -->
              <el-table-column label="委托编号" align="left" prop="entrustNum" min-width="180" show-overflow-tooltip></el-table-column>
              <!-- 产品编号列 -->
              <el-table-column label="产品编号" align="left" prop="FACTORY_COD" min-width="120" show-overflow-tooltip></el-table-column>
              <!-- 使用地址列 -->
              <el-table-column label="使用地址" align="left" prop="EQP_USE_ADDR" min-width="200" show-overflow-tooltip></el-table-column>
              <!-- 设备所在县区列 -->
              <el-table-column label="设备所在县区" align="left" prop="EQP_AREA_NAME" min-width="260" show-overflow-tooltip></el-table-column>
              <!-- 层数/高度/长度列 -->
              <el-table-column label="层数/高度/长度" align="left" prop="ELEFLOORNUMBER" min-width="120" show-overflow-tooltip></el-table-column>
              <!-- 设备品种列 -->
              <el-table-column label="设备品种" align="left" prop="eqpVartName" min-width="120" show-overflow-tooltip></el-table-column>
              <!-- 到检年月列 -->
              <el-table-column label="到检年月" align="left" prop="inspectionMonth" min-width="120" show-overflow-tooltip></el-table-column>
              <!-- 计划检测时间列 -->
              <el-table-column label="派单日期" align="left" prop="orderDate" min-width="120" show-overflow-tooltip :formatter="$tableDateFormatter"></el-table-column>
              <!-- 实际检测时间列 -->
              <el-table-column label="检测时间" align="left" prop="testEmployeeDate" min-width="120" show-overflow-tooltip :formatter="$tableDateFormatter"></el-table-column>
              <!-- 检测员列 -->
              <el-table-column label="检测员" align="left" prop="employeeName" min-width="100" show-overflow-tooltip></el-table-column>

              <!-- 符合性声明情况列：已上传显示上传日期（几月几号） -->
              <el-table-column label="符合性声明情况" align="left" prop="conformanceStatus" min-width="130" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag :type="scope.row.conformanceStatus && scope.row.conformanceStatus !== '0' ? 'success' : 'info'">
                    {{ formatConformanceStatus(scope.row.conformanceStatus) }}
                  </el-tag>
                </template>
              </el-table-column>
              <!-- 基准价列 -->
              <el-table-column label="基准价" align="left" prop="testCharge" min-width="100" show-overflow-tooltip></el-table-column>
              <!-- 折扣列 -->
              <el-table-column label="折扣" align="left" prop="custDiscount" min-width="80" show-overflow-tooltip></el-table-column>
              <!-- 125%试验费用列 -->
              <el-table-column label="125%试验费用" align="left" prop="discTestOtherFee" min-width="120" show-overflow-tooltip></el-table-column>
              <!-- 应收检测费（tb_Customer_Info.finalPrice） -->
              <el-table-column label="应收检测费" align="left" prop="finalPrice" min-width="100" show-overflow-tooltip></el-table-column>
              <!-- 应收总金额 = 应收检测费 + 125%试验费用 -->
              <el-table-column label="应收总金额" align="left" prop="totalTestAmount" min-width="100" show-overflow-tooltip></el-table-column>
              <!-- 实收金额列（自动计算：基准价 - 折扣金额） -->
              <el-table-column label="实收金额" align="left" prop="actualReceiptAmount" min-width="100" show-overflow-tooltip></el-table-column>
              <!-- 已回款金额列 -->
              <el-table-column label="收款时间" align="left" prop="receiptTime" min-width="100" show-overflow-tooltip></el-table-column>
              <!-- 收款方式列 -->
              <el-table-column label="收款账号" align="left" prop="receiptMethod" min-width="100" show-overflow-tooltip></el-table-column>
              <!-- 返点列 -->
              <el-table-column label="返点" align="left" prop="payableRebateFee" min-width="100" show-overflow-tooltip></el-table-column>
              <!-- 配合费列 -->
              <el-table-column label="配合费" align="left" prop="cooperationFee" min-width="100" show-overflow-tooltip></el-table-column>
              <!-- 净产值列（自动计算：基准价 - 折扣金额 - 返点金额 - 配合费） -->
              <el-table-column label="净产值" align="left" prop="netAmount" min-width="100" show-overflow-tooltip></el-table-column>
              <!-- 付款时间列 -->
              <el-table-column label="付款时间" align="left" prop="paymentTime" min-width="280" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span
                        v-if="scope.row.cooperationPayTime && scope.row.cooperationPayTime.trim() && scope.row.cooperationPayTime.trim() !== ','">配合费:{{ scope.row.cooperationPayTime.trim().replace(/^,|,$/g, '') }}
                  </span>
                  <span v-if="scope.row.rebatePayTime && scope.row.rebatePayTime.trim() && scope.row.rebatePayTime.trim() !== ','">返点费:{{ scope.row.rebatePayTime.trim().replace(/^,|,$/g, '') }}</span>
                </template>
              </el-table-column>
              <!-- 付款方式列 -->
              <el-table-column label="付款方式" align="left" prop="payType" min-width="140" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag v-if="scope.row.payType && scope.row.payType.includes('1')" type="success">返点费用</el-tag>
                  <span v-if="scope.row.payType && scope.row.payType.includes('1') && scope.row.payType.includes('2')"> </span>
                  <el-tag v-if="scope.row.payType && scope.row.payType.includes('2')" type="success">配合费</el-tag>
                </template>
              </el-table-column>
              <!-- 开票公司列 -->
              <el-table-column label="开票公司" align="left" prop="invoiceSubject" min-width="150" show-overflow-tooltip></el-table-column>
              <el-table-column label="开票日期" align="left" prop="invoiceTime" min-width="120" show-overflow-tooltip :formatter="$tableDateFormatter"></el-table-column>
              <!-- 是否开票列 -->
              <el-table-column label="是否开票" align="left" prop="applyStatus" min-width="100" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag :type="scope.row.applyStatus === '1' ? 'success' : (scope.row.applyStatus === '0' ? 'warning' : 'info')">
                    {{ scope.row.applyStatus === '1' ? '已开票' : (scope.row.applyStatus === '0' ? '开票中' : '未开票') }}
                  </el-tag>
                </template>
              </el-table-column>
              <!-- 报告是否打印列 -->
              <el-table-column label="报告是否打印" align="left" prop="isPrinted" min-width="120" show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag :type="scope.row.isPrinted === '1' ? 'success' : 'info'">
                    {{ scope.row.isPrinted === '1' ? '已打印' : '未打印' }}
                  </el-tag>
                </template>
              </el-table-column>
              <!-- 业务联系人及电话列 -->
              <el-table-column label="业务联系人及电话" align="left" prop="businessContact" min-width="150" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{ scope.row.businessContact }} /{{ scope.row.businessContactTel }}</span>
                </template>
              </el-table-column>
              <!-- 邮寄时间列 -->
              <el-table-column label="邮寄时间" align="left" prop="mailingDate" min-width="120" show-overflow-tooltip :formatter="$tableDateFormatter"></el-table-column>
              <!-- 邮寄地址列 -->
              <el-table-column label="邮寄地址" align="left" prop="mailingAddress" min-width="200" show-overflow-tooltip></el-table-column>
            </el-table>
          </div>

          <!-- 分页组件 -->
          <el-pagination @size-change="handlePageSizeChange" @current-change="getList" :current-page.sync="queryParams.currPage" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                         :page-size="queryParams.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// 导入API接口
import { queryLedgerList, queryLedgerSummary, exportLedger } from '@/api/contract/contract'
// 导入权限按钮组件
import PermissionMethodToolbar from '@/components/button/PermissionMethodToolbar.vue'

export default {
  name: 'LedgerManagement',
  props: {
    // 页面URL，用于权限按钮组件
    url: {
      type: String,
      default: ''
    }
  },
  components: {
    PermissionMethodToolbar
  },
  data () {
    return {
      // 显示搜索条件
      showSearch: true,
      // 筛选条件区域展开（收起后表格区域变高）
      searchFiltersExpanded: false,
      // 表格高度（随视口与筛选区折叠动态计算）
      tableHeight: 420,
      // 表格数据
      tableData: [],
      // 后台返回的合计数据（全量）
      summaryData: {
        totalTestCharge: 0,
        totalNetAmount: 0,
        totalCooperationFee: 0,
        totalFinalPrice: 0
      },
      // 遮罩层
      loading: false,
      // 总条数
      total: 0,
      // 查询参数
      queryParams: {
        currPage: 1,
        pageSize: 1000,
        compNames: '',
        usingUnit: '',
        projectName: '',
        OIDNO: '',
        factoryCod: '',
        eqpAreaName: '',
        eleFloorNumber: null,
        inspectionMonthList: [],
        orderDateRange: [],
        receivedDateRange: [],
        employeeName: '',
        rectifyImgUploadStatus: null,
        ispinfoSubmitMsg: '',
        eqpInnerCod: '',
        receiptStatus: null,
        applyStatus: null,
        isPrinted: null,
        isMailed: null,
        mailingDateRange: [],
        testDateRange: [],
        conformanceStatus: null,
        reportState: ['全部']
      }
    };
  },
  mounted () {
    this.updateTableHeight()
    window.addEventListener('resize', this.handleWindowResize, { passive: true })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleWindowResize)
  },
  watch: {
    searchFiltersExpanded () {
      this.updateTableHeight()
    }
  },
  methods: {
    /** 符合性声明：有 uploadDate 显示 yyyy-MM-dd，否则未上传 */
    formatConformanceStatus (val) {
      if (val == null || val === '' || val === '0') {
        return '未上传'
      }
      return val
    },
    handleWindowResize () {
      this.updateTableHeight()
    },

    /**
     * 报告状态多选：选「全部」则只保留全部；选具体状态则去掉「全部」；清空后恢复为全部
     */
    onReportStateChange (vals) {
      if (!vals || vals.length === 0) {
        this.queryParams.reportState = ['全部']
        return
      }
      const last = vals[vals.length - 1]
      if (last === '全部') {
        this.queryParams.reportState = ['全部']
        return
      }
      this.queryParams.reportState = vals.filter(v => v !== '全部')
    },

    /**
     * 查询/导出前规范化报告状态：选「全部」时不按状态过滤
     */
    buildQueryParams () {
      const params = { ...this.queryParams }
      const states = params.reportState || []
      if (states.length === 0 || states.includes('全部')) {
        params.reportState = []
      }
      return params
    },

    /**
     * 按视口与表格区域位置计算表格高度，随筛选区折叠/窗口尺寸变化
     */
    updateTableHeight () {
      this.$nextTick(() => {
        const wrap = this.$refs.ledgerTableWrap
        if (!wrap || typeof window === 'undefined') return
        const top = wrap.getBoundingClientRect().top
        const paginationReserve = 56
        const bottomGap = 28
        // top 为负（容器已滚出视口上方）时按 0 计，避免算出过大 height
        const spaceBelow = window.innerHeight - Math.max(0, top)
        const h = spaceBelow - paginationReserve - bottomGap
        this.tableHeight = Math.max(240, Math.floor(h))
        this.$nextTick(() => {
          const t = this.$refs.ledgerTable
          if (t && typeof t.doLayout === 'function') {
            t.doLayout()
          }
        })
      })
    },

    /**
     * 搜索按钮点击事件
     */
    handleQuery () {
      this.queryParams.currPage = 1
      this.searchFiltersExpanded = false
      this.getList()
    },

    /** 每页条数变更：须写入 queryParams，否则接口仍用旧 pageSize */
    handlePageSizeChange (pageSize) {
      this.queryParams.pageSize = pageSize
      this.queryParams.currPage = 1
      this.getList()
    },

    /**
     * 查询列表数据
     */
    getList () {
      this.loading = true

      const params = this.buildQueryParams()
      const summaryParams = { ...params }
      delete summaryParams.currPage
      delete summaryParams.pageSize

      queryLedgerList(params).then(res => {
        if (res.retCode === 'ok') {
          const records = res.additionalData.records || res.additionalData.list || []
          this.total = res.additionalData.total
          if (res.additionalData.summary) {
            this.summaryData = res.additionalData.summary
          }
          // 冻结数据，减少 Vue2 对 1000 行做深度响应式转换的开销
          this.tableData = Object.freeze(records)
          this.loading = false
          this.$nextTick(() => {
            this.updateTableHeight()
          })
        } else {
          this.$message.error(res.retMsg)
          this.loading = false
        }
      }).catch(error => {
        console.error('查询失败:', error)
        this.$message.error('查询失败')
        this.loading = false
      })

      queryLedgerSummary(summaryParams).then(res => {
        if (res.retCode === 'ok' && res.additionalData) {
          this.summaryData = res.additionalData
        }
      }).catch(error => {
        console.error('合计加载失败:', error)
      })
    },

    /**
     * 计算实收金额
     * 实收金额 = 基准价 - 折扣金额
     * @param {Object} row - 当前行数据
     * @returns {String} 计算后的实收金额
     */
    calculateActualAmount (row) {
      const basePrice = parseFloat(row.basePrice) || 0
      const discount = parseFloat(row.discount) || 0
      const actualAmount = (basePrice - discount).toFixed(2)
      return actualAmount
    },

    /**
     * 计算净额
     * 净额 = 基准价 - 折扣金额 - 返点金额 - 配合费
     * @param {Object} row - 当前行数据
     * @returns {String} 计算后的净额
     */
    calculateNetAmount (row) {
      const basePrice = parseFloat(row.basePrice) || 0
      const discount = parseFloat(row.discount) || 0
      const rebate = parseFloat(row.rebate) || 0
      const coordinationFee = parseFloat(row.coordinationFee) || 0
      const netAmount = (basePrice - discount - rebate - coordinationFee).toFixed(2)
      return netAmount
    },
    /**
     * 表格合计行（使用后台返回的全量汇总）
     * 仅显示：基准价、实收金额、配合费、净产值；其他列显示 "-"
     */
    getSummaries ({ columns }) {
      const totalMap = {
        testCharge: this.summaryData.totalTestCharge,
        discTestOtherFee: this.summaryData.totalDiscTestOtherFee,
        finalPrice: this.summaryData.totalFinalPrice,
        totalTestAmount: this.summaryData.totalTestAmount,
        actualReceiptAmount: this.summaryData.totalActualReceiptAmount,
        payableRebateFee: this.summaryData.totalPayableRebateFee,
        cooperationFee: this.summaryData.totalCooperationFee,
        netAmount: this.summaryData.totalNetAmount
      }

      return columns.map((column, index) => {
        if (index === 0) return '合计'
        if (Object.prototype.hasOwnProperty.call(totalMap, column.property)) {
          const value = Number(totalMap[column.property] || 0)
          return value.toFixed(2)
        }
        return '-'
      })
    },

    /**
     * 导出按钮点击事件
     */
    exportToExcel () {
      this.$message.success('正在导出综合台账数据...')

      // 调用导出接口
      exportLedger(this.buildQueryParams()).then(response => {
        // 创建Blob对象
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);

        // 创建下载链接
        const link = document.createElement('a');
        link.href = url;
        link.download = '综合台账管理.xlsx';

        // 触发下载
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();

        // 清理
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$message.success('导出成功')
      }).catch(error => {
        console.error('导出失败:', error)
        this.$message.error('导出失败：' + (error.message || '未知错误'))
      })
    }
  }
}
</script>

<style scoped>
/* 容器样式 */
.app-container {
  padding: 20px;
}

.ledger-search-toggle-row {
  margin-bottom: 4px;
}

.ledger-search-toggle-col {
  text-align: right;
  line-height: 1;
}

.ledger-search-toggle-btn {
  padding: 0 4px;
  font-size: 13px;
}

/*
 * Element UI：固定列与合计行并存时，固定层会叠在表体滚动条上方，导致横向滚动条无法拖拽或表头/合计与内容错位。
 * 让固定层不拦截指针事件，其子节点恢复可点可选（见 https://github.com/ElemeFE/element/issues/22497）。
 * 勿再随意提高 .el-table__body-wrapper 的 z-index，易与合计行、固定列补丁条叠放冲突。
 */
.ledger-mgmt-table ::v-deep .el-table__fixed,
.ledger-mgmt-table ::v-deep .el-table__fixed-right {
  pointer-events: none;
}

.ledger-mgmt-table ::v-deep .el-table__fixed *,
.ledger-mgmt-table ::v-deep .el-table__fixed-right * {
  pointer-events: auto;
}
</style>